import styled from "styled-components";
import { COLORS, WEIGHT } from "../../../layout/theme";
import { Button } from "antd";

export const Inner = styled.div``;

export const InnerForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

export const DistributorContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const AntdButton = styled(Button)`
	${(props) =>
		props.height &&
		`
      height: ${props.height}px;
    `}
	${(props) =>
		props.width &&
		`
      width: ${props.width}px;
    `}
  
  ${(props) => props.fontSize && `font-size: ${props.fontSize}px`}

  border-radius: 20px;

	background-color: ${(props) =>
		props.backGroundColor ? props.backGroundColor : COLORS.Secondary};
	color: ${COLORS.White};
	font-weigth: ${WEIGHT.Bold};

	span {
		${(props) =>
			props.height &&
			`
        height: ${props.height}px;
      `}
		${(props) => props.fontSize && `font-size: ${props.fontSize}px`}
	}
`;
